import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { getBookLinks, getPrimaryNavLinks, getSecondaryNavLinks } from './navlinks';
var esPrimaryNav = getPrimaryNavLinks(['Estudio', 'Tareas', 'Ayuda con la tarea', 'Entender un tema', 'Escritura y citas', 'Herramientas', 'Preguntas y respuestas de expertos', 'Soluciones de los libros de texto', 'Solucionador de matemáticas', 'Citas', 'Controlador de plagio', 'Controlador de gramática', 'Corrección de expertos', 'Carrera profesional', 'Entrenamientos intensivos', 'Consejos profesionales', 'Laboratorio de aprendizaje']);
var esSecondaryNav = getSecondaryNavLinks(['Para educadores', 'Ayuda', 'Iniciar sesión']);
var esBooks = getBookLinks(['Libros', 'Alquilar/Comprar', 'Leer', 'Devolver', 'Vender']);
export var spanishContentIntl = {
  PrimaryNav: esPrimaryNav,
  SecondaryNav: esSecondaryNav,
  experimentIds: []
};
export var spanishContentUS = {
  PrimaryNav: [esBooks].concat(_toConsumableArray(esPrimaryNav)),
  SecondaryNav: esSecondaryNav,
  experimentIds: []
};